import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const routerOptions = [
  {
    path: '/',
    name: 'home',
    component: 'Home',
  },
  {
    path: '/authen',
    name: 'authen',
    component: 'Authen',
  },
  {
    path: '/paymentMethods',
    name: 'paymentMethods',
    component: 'PaymentMethods',
  },
  {
    path: '/paymentInput/:method',
    name: 'paymentInput',
    component: 'PaymentInput',
  },
  {
    path: '/credit/:method',
    name: 'credit',
    component: 'Credit',
  },
  {
    path: '/qr/:method',
    name: 'qr',
    component: 'QR',
  },
  {
    path: '/scbeasy/:method',
    name: 'scbeasy',
    component: 'ScbEasy',
  },
  {
    path: '/paymentProcessing',
    name: 'paymentProcessing',
    component: 'PaymentProcessing',
  },
  {
    path: '/paymentSuccess',
    name: 'paymentSuccess',
    component: 'PaymentSuccess',
  },
  {
    path: '/paymentFail',
    name: 'paymentFail',
    component: 'PaymentFail',
  },
  {
    path: '/billRecieve',
    name: 'billRecieve',
    component: 'BillRecieve',
  },
]

const routes = routerOptions.map((route) => {
  return {
    path: route.path,
    name: route.name,
    component: () => import(`./views/${route.component}.vue`),
    meta: route.meta,
  }
})

const router = new Router({
  mode: 'history',
  routes: [
    ...routes,
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  let filter = ['paymentMethods', 'paymentInput', 'credit']
  if (filter.includes(to.name)) {
    store.commit('LOADING')
    store
      .dispatch('getBillDataStatus', to.query.linkcode)
      .then(() => {
        if (
          store.state.billDataStatus > 3 &&
          store.state.billData.total == store.state.billData.paid
        ) {
          next('/billRecieve/?linkcode=' + to.query.linkcode)
        } else {
          next()
        }
      })
      .then(() => {
        store.commit('LOAD_DONE')
      })
  } else {
    next()
  }
})

export default router
